import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import renderDecimalTextField from '../Complements/renderDecimalTextFiel';

const validate = values => {
    const error  = {}

    const patternAmount = new RegExp('^[0-9]+([.][0-9]{1,2})?$')

    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(values.email)) {
        error.email = 'Correo electrónico no valido'
    }
    if (!values.email) {
        error.email = "El email es un campo obligatorio"
    }
    if (!values.amount) {
        error.amount = "El monto es un campo obligatorio"
    }
    if (parseFloat(values.amount) <= 0) {
        error.amount = "El monto debe ser mayor a 0"
    }
    if (!patternAmount.test(values.amount)) {
        error.amount = "El monto solo debe tener 2 decimales. Ejemplo: 3.22"
    }
    if (!values.concept) {
        error.concept = "La descripción es un campo obligatorio"
    }
    return error
}

class TransferForm extends Component {

    
    render() {
        const {  handleSubmit,  valid, submitting, cancelButton, email  } = this.props;
        
        return (
            <React.Fragment>
                <form  onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                        <Field
                            withFocus
                            autoFocus = {true}
                            name="email"
                            id="email"
                            required
                            defaultValue = {email}
                            component={ RenderTextFieldRedux }
                            label="Correo Electrónico"
                            fullWidth
                            textTransform = { 'lowercase' }
                        />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="amount"
                                id="amount"
                                simbol='$'
                                component={ renderDecimalTextField }
                                label="Monto"
                                fullWidth
                                color = {"#161616"}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="concept"
                                id="concept"
                                required
                                multiline
                                rows="4"
                                upperCase = { true }
                                component={ RenderTextFieldRedux }
                                label="Concepto"
                                autoComplete="off"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" type="submit"
                                disabled={!valid || submitting}
                                color = "primary"
                                fullWidth
                                //color="primary"
                                // className={classes.submit}
                                >
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" onClick = {cancelButton} fullWidth style = {{
                                    fontSize: '0.6rem',
                                    color: '#1a1919',
                                    borderLeft: '3px solid rgba(255, 198, 0)',
                                    backgroundColor: "white",
                                    borderRadius: '0px',
                                    fontFamily: 'Ubuntu',
                                    fontWeight: 'bold'
                                }}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        )
    }
}

const TransferReduxForm = reduxForm(
    {
      form: 'TransferForm',
      validate
    }
)(TransferForm)

export default setPropsAsInitial(TransferReduxForm)